export function format(first: string, middle: string, last: string): string {
  return (
    (first || "") + (middle ? ` ${middle}` : "") + (last ? ` ${last}` : "")
  );
}

export const sortData = (data, orderBy = 'asc', key: string) => {
  const regexAlpha = /[^a-zA-Z]/g;
  const regexNumeric = /[+-]?([0-9]*[.])?[0-9]+/g;
  let order = 1;

  if(orderBy.toLowerCase() === 'desc'){
    order = -1;
  }
  
  const sortedData = data
  .map(item => ({
    ...item,
    children: sortData(item.children || [], orderBy ,key)
  })).sort((a, b) => {
    const itemA = key ? a[key]?.toString() : a.toString();
    const itemB = key ? b[key]?.toString() : b.toString();
    const aAlpha = itemA?.replace(regexAlpha, "");
    const bAlpha = itemB?.replace(regexAlpha, "");

    if (aAlpha === bAlpha) {
      let aNum = itemA?.match(regexNumeric);
      let bNum = itemB?.match(regexNumeric);
      aNum = aNum ? parseFloat(aNum?.join("")) : 0;
      bNum = bNum ? parseFloat(bNum?.join("")) : 0;

      return aNum === bNum ? 0 : aNum < bNum ? -order : order;
    }
    return aAlpha < bAlpha ? -order : order;
  });

  return sortedData;
};
